// extracted by mini-css-extract-plugin
export var bottomLeft = "SpeechBabble-module--bottomLeft--3c41a";
export var bottomRight = "SpeechBabble-module--bottomRight--9e33e";
export var box = "SpeechBabble-module--box--8a3a3";
export var text = "SpeechBabble-module--text--78864";
export var topLeft = "SpeechBabble-module--topLeft--38749";
export var topRight = "SpeechBabble-module--topRight--1a607";